// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__dm-6i","icon":"SortAdornment_icon__1XZwL","up":"SortAdornment_up__2HqPR","down":"SortAdornment_down__2txH0","active":"SortAdornment_active__3j9R-"};